/**
 * Personal notification contract shared by the API and the web client. Kept
 * in sync with apps/api/src/modules/notifications/notifications.schemas.ts.
 */
export const NOTIFICATION_TYPES = [
    'MESSAGE',
    'CONVERSATION',
    'LEAD',
    'TASK',
    'FOLLOW_UP',
    'ORDER',
    'APPOINTMENT',
    'QUOTATION',
    'CATALOG_IMPORT',
    'CHANNEL',
    'SUBSCRIPTION',
    'BILLING',
];
/**
 * What a member can switch off on their Profile page. Every notification
 * belongs to exactly one category; a category nobody touched is on.
 */
export const NOTIFICATION_CATEGORIES = [
    {
        key: 'LEADS',
        label: 'Leads',
        description: 'New leads (from any source) and leads assigned to you.',
    },
    {
        key: 'CONVERSATIONS',
        label: 'WhatsApp chats',
        description: 'A new customer starts a chat, and new messages in chats assigned to you.',
    },
    {
        key: 'TASKS',
        label: 'Tasks & follow-ups',
        description: 'When a task or follow-up is due, and when it is a day overdue.',
    },
    {
        key: 'ORDERS',
        label: 'Orders',
        description: 'New orders, orders cancelled by the customer, and orders pending over 24 hours.',
    },
    {
        key: 'APPOINTMENTS',
        label: 'Appointments',
        description: 'Appointments booked, rescheduled or cancelled by customers.',
    },
    {
        key: 'QUOTATIONS',
        label: 'Quotations & AI jobs',
        description: 'Quotations sent on WhatsApp, and your AI quotation / catalog import results.',
    },
    {
        key: 'ACCOUNT',
        label: 'Account & billing',
        description: 'WhatsApp connection problems, trial ending, plan renewals and invoices.',
    },
];
//# sourceMappingURL=notifications.js.map